import { render, staticRenderFns } from "./MyFirst.vue?vue&type=template&id=6e580390&scoped=true"
import script from "./MyFirst.vue?vue&type=script&lang=js"
export * from "./MyFirst.vue?vue&type=script&lang=js"
import style0 from "./MyFirst.vue?vue&type=style&index=0&id=6e580390&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e580390",
  null
  
)

export default component.exports